module.exports = __webpack_public_path__ + "img/close.aaa74b34.png";